<template>
  <div id="app">
    <section id="contentCnt">
      <router-view/>
    </section>
  </div>
</template>

<script>
export default {
  name: 'home',
  components: {},
  data() {
    return {};
  },
  methods: {},
  mounted() {
    this.$http.get(this.$config.uri('page/all?detail=y'));
  },
};
</script>

<style lang="scss">
* {
  box-sizing: border-box;
}
body{
  margin: 0;
  padding: 0;
  font-family: 'SegoeUI', 'Roboto', sans-serif;
  color: #444;
  line-height: 1.5;
  background-color: #f5f5f5;
  input, textarea, select, button{
    font-family: 'SegoeUI', 'Roboto', sans-serif;
  }
  &.stopscroll{
    overflow: hidden;
  }
  &.hideFooter{
    footer{
      display: none;
    }
  }
}
#contentCnt{
  min-height: 100vh;
  box-sizing: border-box;
  padding-top: 74px;
  @media (max-width: 1480px) {
    padding-top: 64px;
  }
}

/**
 * Container
 *
 */
.cnt{
  max-width: 1320px;
  margin: 0 auto;
  @media (max-width: 1480px) {
    max-width: 1200px;
  }
  @media (max-width: 1260px) {
    max-width: none;
    margin: 0 30px;
  }
  @media (max-width: 960px) {
    margin: 0 20px;
  }
}

/**
 * Tab
 *
 */
.tabCnt{
  border-bottom: #ddd 1px solid;
  .cnt{
    display: flex;
    justify-content: center;
    .tabItem{
      padding: 10px 20px;
      font-size: 16px;
      font-weight: 500;
      color: #767676;
      cursor: pointer;
      transition: all .3s ease;
      position: relative;
      &:before{
        content: "";
        transition: all .3s ease;
        height: 3px;
        position: absolute;
        left: 0; right: 0; bottom: 0;
        border-radius: 50px 50px 0 0;
      }
      &:hover{
        color: #444;
        &:before{
          background-color: #ccc;
        }
      }
      &.active{
        color: #008552;
        &:before{
          background-color: #008552;
        }
      }
    }
  }
}

/**
 * Custom block
 *
 */
.customBlockCnt{
  iframe{
    display: block;
    margin: 0 auto;
  }
  .twitter-tweet, .instagram-media{
    margin: 0 auto !important;
  }
}

/**
 * Swiper for icon slider
 *
 */
.iconSlider{
  .swiperCnt{
    .swiper-pagination.swiper-pagination-bullets{
      bottom: -4px;
      display: none;
      @media (max-width: 640px) {
        display: block;
      }
      .swiper-pagination-bullet.swiper-pagination-bullet-active{
        background-color: #008552;
      }
    }
  }
}

/**
 * Map
 *
 */
.cst-marker-popup{
  .mapboxgl-popup-content{
    padding: 16px 20px 12px;
    box-sizing: border-box;
    border-radius: 7px;
    img{
      width: 100%; height: auto;
      margin: 4px 0 10px;
      border-radius: 5px;
    }
    h4{
      margin: 0 0 4px;
      font-size: 17px;
    }
    p{
      margin: 0 0 4px;
      font-size: 14px;
      line-height: 1.34;
    }
    .btn{
      padding: 10px 16px;
      font-size: 14px;
      font-weight: 500;
      margin: 6px 0;
      display: inline-block;
      transition: box-shadow .3s ease, background-color .3s ease, color .3s ease, border-color .3s ease;
      &:hover{
        background-color: #008552;
        border-color: #008552;
        color: #fff;
      }
    }
    .mapboxgl-popup-close-button{
      background-color: #eee;
      width: 22px; height: 22px;
      border-radius: 50%;
      color: #767676;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 18px;
      font-weight: 400;
      right: -6px; top: -6px;
      &:hover{
        background-color: #e5e5e5;
        color: #555;
        box-shadow: 2px 2px 4px rgba(0, 0, 0, .1);
      }
    }
  }
}

.sectionHeader{
  text-align: center;
  .sectionTitle{
    font-weight: 700;
    font-size: 1.5625rem;
    margin: 0;
  }
  .sectionDesc{
    color: #5a5a5a;
    padding-bottom: 1.2rem;
    max-width: calc(max(50%,25rem));
    margin: 0 auto;
  }
}

.related{
  padding: 0 0 60px;
  margin-top: -20px;
  h4{
    margin: 0;
    font-size: 24px;
    padding: 60px 0 20px;
    @media (max-width: 680px) {
      padding-top: 40px;
    }
  }
  .relatedCnt{
    &.merchandise{
      margin: 0 -10px;
    }
    @media (max-width: 860px) {
      overflow-x: auto;
    }
    .relatedSc{
      display: flex;
      justify-content: space-between;
      @media (max-width: 860px) {
        width: 940px;
      }
      @media (max-width: 680px) {
        width: 780px;
      }
      .relatedItem{
        width: calc(25% - 20px);
        box-sizing: border-box;
        .relatedImg{
          height: 200px;
          margin: 0 0 10px;
          background-size: cover;
          background-position: center;
          background-repeat: no-repeat;
          border-radius: 5px;
          @media (max-width: 860px) {
            height: 154px;
          }
          @media (max-width: 680px) {
            height: 120px;
          }
          &.noImg{
            background-color: #ccc;
            background-image: url(assets/image-black.png);
            background-size: 46px auto;
            opacity: .36;
          }
        }
        h4{
          margin: 0 0 4px;
          padding: 0;
          font-size: 17px;
          font-weight: 600;
          color: #444;
        }
        p{
          margin: 0;
          font-size: 14px;
          color: #767676;
          text-overflow: ellipsis;
          overflow: hidden;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          line-clamp: 2;
          -webkit-box-orient: vertical;
        }
        &.row3{
          width: calc(33.33333% - 20px);
          .relatedImg{
            height: 240px;
            @media (max-width: 860px) {
              height: 200px;
            }
            @media (max-width: 680px) {
              height: 146px;
            }
          }
        }
        &.donation{
          text-align: center;
          .btn{
            margin-top: 14px;
            border-radius: 50px;
            padding: 0 24px;
            height: 44px;
            font-size: 17px;
            background-color: #ff0400;
          }
        }
        &.merchandise{
          text-align: center;
          padding: 10px 10px 20px;
          border: #fff 1px solid;
          transition: all .3s ease;
          &:hover{
            border-color: #eee;
          }
          .priceCntRlt{
            display: flex;
            justify-content: center;
            font-size: 14px;
            margin: 0 0 14px;
            @media (max-width: 680px) {
              display: block;
            }
            .priceDiscount{
              margin-right: 10px;
              color: red;
              text-decoration: line-through;
              @media (max-width: 680px) {
                margin: 0;
              }
            }
          }
          .btn{
            // width: 100%;
            border-radius: 50px;
            padding: 0 14px;
            height: 34px;
            font-size: 15px;
          }
          .relatedImg{
            background-color: #fff;
            background-size: contain;
            height: 240px;
            @media (max-width: 1140px) {
              height: 200px;
            }
            @media (max-width: 860px) {
              height: 180px;
            }
            @media (max-width: 680px) {
              height: 130px;
            }
            &.noImg{
              background-color: #ccc;
              background-image: url(assets/image-black.png);
              background-size: 46px auto;
              opacity: .36;
            }
          }
        }
      }
    }
  }
}

/**
 * Page sections
 *
 */
.features{
  padding: 80px 0;
  @media (max-width: 960px) {
    padding: 60px 0;
  }
  @media (max-width: 640px) {
    padding: 50px 0;
  }
}

/**
 * Modal
 *
 */
.modalAction{
  .btn{
    height: 44px;
    padding-bottom: 1px;
    border-radius: 3px;
    padding-top: 0;
    &.loading{
      background-size: 28px auto;
    }
    &.primary{
      min-width: 114px;
    }
  }
}
.modalContent{
  transition: all .2s ease;
  .close{
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background-image: url(assets/close.png);
    background-size: 14px auto;
    background-position: center;
    background-repeat: no-repeat;
    position: absolute;
    right: 10px;
    top: 10px;
    opacity: .4;
    cursor: pointer;
    transition: all .2s linear;
    &:hover{
      background-color: #e5e5e5;
      opacity: .7;
    }
  }
}
.fade-enter-active,
.fade-leave-active {
  transition: all .2s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
  .modalContent{
    transform: scale(.9);
  }
}

/**
 * Loading
 *
 */
.loadingFull{
  height: 100vh;
  background-image: url(assets/loading.svg);
  background-size: 46px auto;
  background-position: center;
  background-repeat: no-repeat;
}

/**
 * Footer & FAB
 *
 */
.fabMenu{
  position: fixed;
  z-index: 991;
  right: 30px; bottom: 80px;
  background-color: #fff;
  border-radius: 5px;
  padding: 10px 0;
  box-shadow: 2px 2px 8px rgba(0, 0, 0, .2);
  margin-bottom: 10px;
  transform-origin: right bottom;
  transform: scale(0);
  transition: all .2s ease;
  &.open{
    transform: scale(1);
  }
  a{
    display: block;
    white-space: nowrap;
    padding: 10px 30px;
    color: #444;
    font-weight: 600;
    transition: all .3s ease;
    &:hover{
      background-color: #f5f5fe;
    }
    span{
      display: block;
      font-size: 14px;
      font-weight: 400;
      padding-left: 24px;
      position: relative;
      padding-top: 4px;
      &:before{
        content: "";
        position: absolute;
        width: 16px; height: 16px;
        left: 0; top: 5px;
        background-image: url(assets/whatsapp-green.png);
        background-size: 16px auto;
        background-position: center;
        background-repeat: no-repeat;
      }
    }
  }
}
.fab{
  width: 60px; height: 60px;
  border-radius: 50%;
  background-color: #008552;
  position: fixed;
  right: 30px; bottom: 30px;
  z-index: 991;
  background-image: url(assets/question2-white.png);
  background-size: 32px auto;
  background-position: center;
  background-repeat: no-repeat;
  box-shadow: 2px 2px 6px rgba(0, 0, 0, .2);
  display: block;
  cursor: pointer;
  transition: all .3s ease;
  @media (max-width: 1480px) {
    width: 50px; height: 50px;
    background-size: 26px auto;
  }
  @media (max-width: 760px) {
    right: 16px; bottom: 20px;
  }
  &:hover{
    box-shadow: 2px 2px 8px rgba(0, 0, 0, .3);
    background-color: #006a42;
  }
  &.open{
    background-image: url(assets/close-white.png);
    transform: rotate(180deg);
    background-size: 18px auto;
  }
}

a{
  text-decoration: none;
  color: #008552;
  &:hover{ color: #006a42; }
}
.checkCnt{
  position: relative;
}
.checkbox{
  width: 14px; height: 14px;
  border: #999 2px solid;
  border-radius: 3px;
  position: absolute;
  left: 20px; top: 50%;
  margin-top: -9px;
  cursor: pointer;
  &:hover{
    border-color: #035fae;
  }
  &.indeterminate{
    border-color: #035fae !important;
    background-color: #035fae !important;
    &:before{
      content: "";
      position: absolute;
      top: 50%; left: 2px; right: 2px;
      height: 2px;
      background-color: #fff;
      border-radius: 50px;
      margin-top: -1px;
    }
  }
  &.checked{
    border-color: #035fae;
    background-color: #035fae;
    background-image: url(assets/checked.png);
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
  }
}
.tooltip{
  color: #fff;
  background-color: rgba(0, 0, 0, .84);
  padding: 6px 10px 4px;
  border-radius: 3px;
  font-size: 12px;
  position: relative;
  transition-delay: 250ms;
  transition: all .3s ease;
  &:before{
    content: "";
    position: absolute;
  }
  &.right{
    &:before{
      right: -6px; top: 50%;
      margin-top: -6px;
      border-left: rgba(0, 0, 0, .84) 6px solid;
      border-top: transparent 6px solid;
      border-bottom: transparent 6px solid;
    }
  }
  &.left{
    &:before{
      left: -6px; top: 50%;
      margin-top: -6px;
      border-right: rgba(0, 0, 0, .84) 6px solid;
      border-top: transparent 6px solid;
      border-bottom: transparent 6px solid;
    }
  }
}

/**
 * Custom ccrollbar
 *
 */
.ps__rail-y .ps__thumb-y{
  background-color: #767676;
}
.ps__rail-y:hover > .ps__thumb-y,
.ps__rail-y:focus > .ps__thumb-y,
.ps__rail-y.ps--clicking .ps__thumb-y{
  background-color: #767676;
}

/**
 * Form field
 *
 */
 .field{
  border: #ccc 1px solid;
  border-radius: 5px;
  padding: 12px 14px 10px;
  font-size: 17px;
  background-color: #fff;
  outline: 0;
  box-shadow: none;
  width: 100%;
  box-sizing: border-box;
  line-height: 1.4;
  &.disabled{
    background-color: #f5f5f5;
  }
  &:hover{
    border-color: #999;
    box-shadow: 0 0 0 1px #999;
  }
  &:focus{
    border-color: #002f5f;
    box-shadow: 0 0 0 1px #002f5f;
  }
}
.fieldGroup{
  margin-bottom: 16px;
  label{
    display: block;
    text-transform: uppercase;
    font-weight: bold;
    font-size: 12px;
    color: #999;
    margin-bottom: 5px;
    padding-left: 7px;
  }
  .fieldCnt{
    position: relative;
    &.hasError{
      .field{
        border-color: red;
        box-shadow: 0 0 0 1px red;
      }
      .fieldError{
        display: block;
      }
      .hint{
        display: none;
      }
    }
    &.hasPrefix{
      .field{
        padding-left: 60px;
      }
      .prefix{
        position: absolute;
        left: 1px; top: 1px; bottom: 1px;
        background-color: #eee;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 5px 0 0 5px;
        padding: 0 10px;
        border-right: #e5e5e5 1px solid;
      }
    }
    .showPwd{
      width: 30px; height: 30px;
      position: absolute;
      right: 8px; top: 50%;
      margin-top: -15px;
      border-radius: 50%;
      background-image: url(assets/eye-closed.png);
      background-size: 20px auto;
      background-position: center;
      background-repeat: no-repeat;
      cursor: pointer;
      transition: all .3s ease;
      opacity: .8;
      &:hover{
        background-color: #eee;
        opacity: 1;
      }
      &.show{
        background-image: url(assets/eye.png);
      }
    }
  }
  .fieldError{
    color: #ff7979;
    font-size: 12px;
    margin: 6px 0 0 7px;
  }
  .hint{
    color: #767676;
    font-size: 12px;
    margin: 0;
    padding: 6px 0 0 7px;
  }
  &.hasError{
    .field{
      border-color: #fff;
      box-shadow: 0 0 0 2px red;
    }
    .hint{
      display: none;
    }
  }
  &.fg2{
    display: flex;
    justify-content: space-between;
    .fieldCnt{
      width: calc(50% - 8px);
      position: relative;
    }
  }
  &.fg2a{
    display: flex;
    justify-content: space-between;
    .fieldCnt{
      width: calc(60% - 8px);
      position: relative;
      &.fc2{
        width: calc(40% - 8px);
      }
    }
  }
}

.btn{
  border: none;
  padding: 12px 16px;
  border-radius: 6px;
  font-size: 17px;
  outline: 0 !important;
  cursor: pointer;
  transition: all .3s ease;
  background-size: 36px auto;
  background-position: center;
  font-weight: 600;
  background-color: #fff;
  display: inline-block;
  background-repeat: no-repeat;
  &:hover{
    box-shadow: 2px 2px 2px rgba(0,0,0,.1);
  }
  &:focus{
    outline: #bcd4ca 4px solid !important;
  }
  &.lg{
    font-size: 20px;
    padding: 12px 24px;
  }
  &.sm{
    font-size: 16px;
    padding: 8px 14px 10px;
  }
  &.secondary{
    background: none;
    color: #008552;
    &:hover{
      color: #006a42;
    }
    &.negative{
      color: red;
    }
  }
  &.primary{
    background-color: #008552;
    color: #fff;
    &:hover{
      background-color: #006a42;
    }
  }
  &.outline{
    color: #444;
    border: #eee 2px solid;
  }
  &.loading{
    background-image: url(assets/loading.svg);
    background-color: #ccc !important;
    color: #999 !important;
    box-shadow: none !important;
    cursor: default;
    span{
      // display: none;
      visibility: hidden;
    }
  }
  &.disabled{
    background-color: #ccc !important;
    color: #999 !important;
    box-shadow: none !important;
    cursor: default;
    span{
      // visibility: hidden;
    }
  }
}

@keyframes loved {
  0% { transform: scale(1); }
  75% { transform: scale(1.3); }
  100% { transform: scale(1); }
}

.notFoundCnt{
  position: relative;
  height: calc(100vh - 74px);
  background-color: #fff;
  @media (max-width: 1480px) {
    height: calc(100vh - 64px);
  }
  .notFound{
    position: absolute;
    left: 40px; right: 40px;
    top: 50%; transform: translateY(-50%);
    text-align: center;
    color: #767676;
    img{
      height: auto;
      width: 100%;
      max-width: 360px;
      margin-bottom: 40px;
    }
    h2{
      margin: 0 0 4px;
      font-size: 26px;
      line-height: 1;
    }
    h4{
      margin: 0 0 10px;
      font-size: 40px;
      line-height: 1;
    }
    .btn{
      margin-top: 20px;
    }
    p{
      margin: 0;
    }
  }
}

/**
 * Video player
 *
 */
#app #contentCnt{
  .plyr--video .plyr__control.plyr__tab-focus, .plyr--video .plyr__control:hover, .plyr--video .plyr__control[aria-expanded=true]{
    background-color: #008552;
  }
  .plyr__control--overlaid{
    background-color: #008552;
  }
  .plyr--full-ui input[type=range]{
    color: #008552;
  }
}
</style>
